import { render } from "./MaintenanceDetail.vue?vue&type=template&id=fbd3273a&scoped=true"
import script from "./MaintenanceDetail.vue?vue&type=script&lang=js"
export * from "./MaintenanceDetail.vue?vue&type=script&lang=js"

import "./MaintenanceDetail.vue?vue&type=style&index=0&id=fbd3273a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbd3273a"]])

export default __exports__